export interface AppSettings {
  dir: 'ltr' | 'rtl';
  theme: string;
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  boxed: boolean;
  horizontal: boolean;
  activeTheme: string;
  language: string;
  cardBorder: boolean;
  navPos: 'side' | 'top';
}

export const defaults: AppSettings = {
  dir: 'ltr',
  theme: 'light',
  sidenavOpened: false,
  sidenavCollapsed: true,
  boxed: false,
  horizontal: false,
  cardBorder: true,
  activeTheme: 'blue_theme',
  language: 'en-us',
  navPos: 'side',
};

export interface User {
  BearerToken: string;
  id: number;
  name: string;
  email: string;
  user_type: 'user' | 'client';
  // Se user_type === 'user':
  role?: 'commercial' | 'supplier';
  is_admin?: boolean;
  // Se user_type === 'client':
  client_id?: number;
  brand_id?: number;
  /** Se true e user_type === 'client', este user é admin da brand e vê todos os serviços da brand. */
  is_brand_admin?: boolean;
  /**
   * Se true e user_type === 'client', é um "super cliente" (admin Armindohub): vê, em modo
   * apenas-leitura, o que os clientes veem em TODAS as marcas (`brand_id` = null). Nunca é
   * selecionável como cliente nem destinatário. Ver docs/BACKEND-SUPER-CLIENT-GLOBAL-VIEWER-2026-06-08.md.
   */
  is_super_client?: boolean;
  // Campos legados (para compatibilidade)
  first_name?: string;
  last_name?: string;
  id_user?: number;
  admin?: boolean;
  permissions?: string[];
  boards?: any[]; // Para compatibilidade com sistema de permissões antigo
  theme?: number; // Para compatibilidade com tema do utilizador
}